<div class="ibox float-e-margins">
  <div class="ibox-title" ng-show="newTipoOcorrencia.id">Editando</div>
  <div class="ibox-title" ng-hide="newTipoOcorrencia.id">Novo</div>
  <div class="ibox-content">
    <ng-include src="'views/tipos_ocorrencias/_form.html'"></ng-include>
  </div>
</div>